import { apiClient } from '@/lib/api-client';

export interface ProjectElement {
  id: string;
  name: string;
}

export interface ProjectElementCategory {
  categoryName: string;
  categoryId: string;
  isAvailable: boolean;
  elements: ProjectElement[];
}

export type ProjectElementsResponse = ProjectElementCategory[];

export const projectElementsService = {
  getAvailableElements: async (): Promise<ProjectElementCategory[]> => {
    return apiClient.get<ProjectElementCategory[]>('/projects/elements/available');
  },
};
